var map = {
	"./athletes-2m-ic.svg": 930,
	"./athletes-ic.svg": 931,
	"./balanced-2m-ic.svg": 932,
	"./balanced-ic.svg": 933,
	"./balanced-new-ic.svg": 934,
	"./customized-plan-ic.svg": 935,
	"./flexible-carnivore-ic.svg": 936,
	"./flexible-carnivore-new-ic.svg": 937,
	"./gain-ic.svg": 938,
	"./gain-new-ic.svg": 939,
	"./keto-ic.svg": 940,
	"./trim-ic.svg": 941,
	"./trim-new-ic.svg": 942,
	"./vegan-ic.svg": 943,
	"./vegetarian-ic.svg": 944,
	"./weight-loss-2m-ic.svg": 945,
	"./weight-loss-ic.svg": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;